import { render } from "./ProfileIDImageInput.vue?vue&type=template&id=b89a1116&scoped=true"
import script from "./ProfileIDImageInput.vue?vue&type=script&lang=js"
export * from "./ProfileIDImageInput.vue?vue&type=script&lang=js"

import "./ProfileIDImageInput.vue?vue&type=style&index=0&id=b89a1116&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89a1116"]])

export default __exports__